



export type Triage = 'ESI-1' | 'ESI-2' | 'ESI-3' | 'ESI-4' | 'ESI-5'

export interface ERPatient {
  id: string
  bay: string
  zone: 'Resus' | 'Red' | 'Yellow' | 'Green'
  name: string
  age: number
  sex: 'M' | 'F'
  triage: Triage
  complaint: string
  arrived: string
  waitMin: number
  provider?: string
  mlc?: boolean
  status: 'Triage' | 'In treatment' | 'Awaiting labs' | 'Disposition' | 'Admit pending'
}

export const erPatients: ERPatient[] = [
  { id: 'er1', bay: 'R-2', zone: 'Resus', name: 'Bilal Ahmed Khan', age: 8, sex: 'M', triage: 'ESI-1', complaint: 'Acute asthma, SpO₂ 89%', arrived: '14:02', waitMin: 3, provider: 'Dr. S. Malik', status: 'In treatment' },
  { id: 'er2', bay: 'R-1', zone: 'Resus', name: 'Unknown Male #3391', age: 45, sex: 'M', triage: 'ESI-1', complaint: 'RTA polytrauma', arrived: '13:48', waitMin: 5, provider: 'Dr. A. Farooq', mlc: true, status: 'In treatment' },
  { id: 'er3', bay: 'A-4', zone: 'Red', name: 'Rukhsana Bibi', age: 61, sex: 'F', triage: 'ESI-2', complaint: 'Chest pain, ? STEMI', arrived: '14:10', waitMin: 8, provider: 'Dr. I. Sethi', status: 'Awaiting labs' },
  { id: 'er4', bay: 'A-6', zone: 'Red', name: 'Tariq Mehmood', age: 52, sex: 'M', triage: 'ESI-2', complaint: 'Stroke — FAST positive', arrived: '13:55', waitMin: 12, provider: 'Dr. K. Ali', status: 'Disposition' },
  { id: 'er5', bay: 'B-2', zone: 'Yellow', name: 'Sadia Noor', age: 34, sex: 'F', triage: 'ESI-3', complaint: 'Abdominal pain', arrived: '13:30', waitMin: 41, status: 'Triage' },
  { id: 'er6', bay: 'B-5', zone: 'Yellow', name: 'Imran Bashir', age: 27, sex: 'M', triage: 'ESI-3', complaint: 'Fracture, right wrist', arrived: '13:12', waitMin: 55, provider: 'Dr. M. Iqbal', status: 'Admit pending' },
  { id: 'er7', bay: 'C-1', zone: 'Green', name: 'Nida Aslam', age: 22, sex: 'F', triage: 'ESI-4', complaint: 'Sore throat, fever', arrived: '14:15', waitMin: 22, status: 'Triage' },
  { id: 'er8', bay: 'C-3', zone: 'Green', name: 'Faisal Yousuf', age: 39, sex: 'M', triage: 'ESI-5', complaint: 'Med refill / minor', arrived: '14:20', waitMin: 18, status: 'Triage' },
]

export interface Bed {
  id: string
  label: string
  status: 'Occupied' | 'Vacant' | 'Cleaning' | 'Maintenance' | 'Reserved'
  patient?: string
  los?: string
  acuity?: 'stable' | 'guarded' | 'critical'
}

export interface Ward {
  name: string
  type: string
  beds: Bed[]
}

export const wards: Ward[] = [
  {
    name: 'Cardiology Ward',
    type: 'General',
    beds: [
      { id: 'c1', label: '401-1', status: 'Occupied', patient: 'A. Iqbal', los: '3d', acuity: 'stable' },
      { id: 'c2', label: '401-2', status: 'Occupied', patient: 'M. Saleem', los: '1d', acuity: 'guarded' },
      { id: 'c3', label: '412-1', status: 'Occupied', patient: 'S. Anwar', los: '5d', acuity: 'stable' },
      { id: 'c4', label: '412-2', status: 'Occupied', patient: 'A. Rahman', los: '3d', acuity: 'guarded' },
      { id: 'c5', label: '413-1', status: 'Cleaning' },
      { id: 'c6', label: '413-2', status: 'Vacant' },
      { id: 'c7', label: '414-1', status: 'Reserved', patient: 'ER admit' },
      { id: 'c8', label: '414-2', status: 'Vacant' },
    ],
  },
  {
    name: 'Intensive Care Unit',
    type: 'Critical',
    beds: [
      { id: 'i1', label: 'ICU-1', status: 'Occupied', patient: 'R. Khan', los: '8d', acuity: 'critical' },
      { id: 'i2', label: 'ICU-2', status: 'Occupied', patient: 'N. Bibi', los: '2d', acuity: 'critical' },
      { id: 'i3', label: 'ICU-3', status: 'Occupied', patient: 'M. Usman', los: '5d', acuity: 'critical' },
      { id: 'i4', label: 'ICU-4', status: 'Occupied', patient: 'W. Shah', los: '1d', acuity: 'guarded' },
      { id: 'i5', label: 'ICU-5', status: 'Maintenance' },
      { id: 'i6', label: 'ICU-6', status: 'Vacant' },
    ],
  },
  {
    name: 'Surgical Ward B',
    type: 'General',
    beds: [
      { id: 's1', label: '201-1', status: 'Occupied', patient: 'H. Malik', los: '2d', acuity: 'stable' },
      { id: 's2', label: '201-2', status: 'Vacant' },
      { id: 's3', label: '202-1', status: 'Occupied', patient: 'J. Ahmed', los: '4d', acuity: 'stable' },
      { id: 's4', label: '202-2', status: 'Occupied', patient: 'K. Riaz', los: '6d', acuity: 'guarded' },
      { id: 's5', label: '203-1', status: 'Cleaning' },
      { id: 's6', label: '203-2', status: 'Vacant' },
    ],
  },
]

export interface Appointment {
  id: string
  time: string
  patient: string
  mrn: string
  type: 'New' | 'Follow-up' | 'Video consultation' | 'Procedure'
  status: 'Scheduled' | 'Checked-in' | 'In consult' | 'Completed' | 'No-show'
  doctor: string
}

export const appointments: Appointment[] = [
  { id: 'ap1', time: '09:00', patient: 'Zara Sheikh', mrn: 'MRN-0055120', type: 'Follow-up', status: 'Completed', doctor: 'Dr. Hassan Raza' },
  { id: 'ap2', time: '09:30', patient: 'Fatima Zafar', mrn: 'MRN-0043019', type: 'Follow-up', status: 'In consult', doctor: 'Dr. Nadia Qureshi' },
  { id: 'ap3', time: '10:00', patient: 'Ali Hamza', mrn: 'MRN-0051088', type: 'New', status: 'Checked-in', doctor: 'Dr. Imran Sethi' },
  { id: 'ap4', time: '10:30', patient: 'Sana Tariq', mrn: 'MRN-0049921', type: 'Video consultation', status: 'Scheduled', doctor: 'Dr. Imran Sethi' },
  { id: 'ap5', time: '11:00', patient: 'Bilal Nawaz', mrn: 'MRN-0052003', type: 'Follow-up', status: 'Scheduled', doctor: 'Dr. Kamran Ali' },
  { id: 'ap6', time: '11:30', patient: 'Hina Aslam', mrn: 'MRN-0053410', type: 'Procedure', status: 'Scheduled', doctor: 'Dr. Hassan Raza' },
  { id: 'ap7', time: '12:00', patient: 'Waqar Younis', mrn: 'MRN-0050012', type: 'New', status: 'No-show', doctor: 'Dr. Nadia Qureshi' },
]

export interface RxQueueItem {
  id: string
  patient: string
  ward: string
  drug: string
  dose: string
  priority: 'STAT' | 'Routine'
  alerts: { type: 'interaction' | 'allergy' | 'duplicate'; text: string }[]
  status: 'Review' | 'Verified' | 'Dispensed'
}

export const rxQueue: RxQueueItem[] = [
  {
    id: 'rx1', patient: 'Ayesha Rahman', ward: 'Cardiology 412-2', drug: 'Ceftriaxone 1g IV', dose: 'BD × 5 days', priority: 'STAT',
    alerts: [{ type: 'allergy', text: 'Penicillin anaphylaxis — cephalosporin cross-reactivity' }], status: 'Review',
  },
  {
    id: 'rx2', patient: 'Muhammad Usman', ward: 'ICU-3', drug: 'Enoxaparin 60mg SC', dose: 'OD', priority: 'Routine',
    alerts: [{ type: 'interaction', text: 'Interacts with Aspirin — bleeding risk' }], status: 'Review',
  },
  {
    id: 'rx3', patient: 'Sara Anwar', ward: 'Cardiology 412-1', drug: 'Atorvastatin 40mg', dose: 'OD nocte', priority: 'Routine',
    alerts: [], status: 'Verified',
  },
  {
    id: 'rx4', patient: 'Waqar Shah', ward: 'ICU-4', drug: 'Pantoprazole 40mg IV', dose: 'OD', priority: 'Routine',
    alerts: [{ type: 'duplicate', text: 'Duplicate therapy — Omeprazole active' }], status: 'Review',
  },
  {
    id: 'rx5', patient: 'Junaid Ahmed', ward: 'Surgical 202-1', drug: 'Paracetamol 1g IV', dose: 'TDS PRN', priority: 'Routine',
    alerts: [], status: 'Dispensed',
  },
]




